var _defs, _rect;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 30 30.55",
    fill: "currentColor"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "profile_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rect\\xE1ngulo redondeado 2 copia 120",
    width: 30,
    height: 30.55,
    rx: 15,
    transform: "translate(354 646)",
    fill: "#ffb04c"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-354 -646)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rect\\xE1ngulo redondeado 2 copia 120"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rect\\xE1ngulo redondeado 2 copia 120",
    width: 30,
    height: 30.55,
    rx: 15,
    transform: "translate(354 646)",
    fill: "#ffb04c"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#profile_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rect\\xE1ngulo redondeado 2 copia 89",
    width: 18.21,
    height: 18,
    rx: 9,
    transform: "translate(359.9 664)",
    fill: "#dbdbdb",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }))), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rect\\xE1ngulo redondeado 2 copia 90",
    width: 12.85,
    height: 13.09,
    rx: 6.425,
    transform: "translate(362.57 649.27)",
    fill: "#dbdbdb",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })));
}

export default SvgProfile;